import { Box, Typography, Grid2 as Grid } from '@mui/material';

import { fDate } from 'src/utils/format-time';
import { fNumber, fCurrency } from 'src/utils/format-number';

import { ReportWidget } from 'src/components/Reports/ReportWidget';

import { PromotionTrends } from './PromotionTrends';

import type { PromotionsSummaryLocationReport } from '../../types';

export function Promotion({ promotion }: { promotion: PromotionsSummaryLocationReport }) {
  return (
    <>
      <Grid size={{ xs: 12 }}>
        <Typography variant="h4">{promotion.eventName}</Typography>
        <Box display="flex" gap="4px">
          <Typography variant="subtitle1">Promotion period:</Typography>
          <Typography variant="body1">
            {fDate(promotion.eventStartDate, 'MMM DD, YYYY')} -{' '}
            {fDate(promotion.eventEndDate, 'MMM DD, YYYY')}
          </Typography>
        </Box>
      </Grid>
      <Grid size={{ xs: 12, md: 3 }}>
        <ReportWidget title="Use count" total={fNumber(promotion.eventUseCount)} />
      </Grid>
      <Grid size={{ xs: 12, md: 3 }}>
        <ReportWidget title="Net sales" total={fCurrency(promotion.orderNetSales)} />
      </Grid>
      <Grid size={{ xs: 12, md: 3 }}>
        <ReportWidget title="Promotion cost" total={fCurrency(promotion.eventDiscount)} />
      </Grid>
      <Grid size={{ xs: 12, md: 3 }}>
        <ReportWidget
          title="Discount percentage"
          total={`${fNumber(promotion.eventDiscountPercentage)}%`}
        />
      </Grid>
      <PromotionTrends promotion={promotion} />
      {/* <Grid key={locationId} size={{ xs: 6, md: 6 }}>
        <CustomerTrendsChart
          subtitle="Number of orders places by new and existing customers"
          categories={uniqueDates}
          loading={loading}
          title={getLocationName(locationId)}
          dataset={getLocationDataset({
            locationId,
            type: 'orders',
          })}
        />
      </Grid> */}
    </>
  );
}
